<div class="acc-scheduled-follow-ups-view-part">
	<common-scheduled-follow-ups-grid [pageService]="pageService" [data]="followUps()"></common-scheduled-follow-ups-grid>
</div>